<script lang="ts" setup>

const props = defineProps<{
  data: string
}>()

function pretify(data) {
  try {
    let formatted = ''
    let indent = ''
    const tab = '\t'
    data.split(/>\s*</).forEach(function(node) {
      if (node.match(/^\/\w/)) {
        indent = indent.substring(tab.length) // decrease indent by one 'tab'
      }
      formatted += `${indent}<${node}>\r\n`
      if (node.match(/^<?\w[^>]*[^/]$/)) {
        indent += tab // increase indent
      }
    })

    return formatted.substring(1, formatted.length - 3)
  } catch (error) {
    return data
  }
}
</script>

<template>
  <div
    class="w-100"
    style="background: #f8f9fa;padding: 15px;border-radius: 10px;"
  >
    <pre>{{ pretify(props.data) }}</pre>
  </div>
</template>
